const isFireFox = (): boolean => {
  return /(?:Firefox)/.test(navigator.userAgent);
};

export default isFireFox;
